import homepage from './homepage'
import resultsQuery from './resultsquery'
import practiceScore from './practiceScore'
import practiceReport from './practiceReport'
import socialPracticeScore from './socialPracticeScore'
import socialPracticeReport from './socialPracticeReport'
import admissionTicket from './admissionTicket'
const studentResults = {
  path: 'studentResults',
  component: resolve => require(['../../../components/pages/studentresults'], resolve),
  redirect: 'studentResults/homepage',
  children: [
    ...resultsQuery,
    ...practiceScore,
    ...practiceReport,
    ...socialPracticeScore,
    ...socialPracticeReport,
    ...admissionTicket,
    homepage
  ]
}
export default studentResults
